import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PoliciesPage } from "@/features/policies/PoliciesPage";

const search = z.object({
  kind: z.enum(["all", "required", "optional"]).optional(),
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/policies/")({
  validateSearch: search,
  component: () => <PoliciesPage search={Route.useSearch()} />,
});
